import { PortfolioGroupDto } from "../../../screens/portfolio-info/types/PortfolioGroupDto";
import { PortfolioGroupCreateDto } from "../../../screens/portfolio-info/types/PortfolioGroupCreateDto";
import { createAuthenticatedApiClient, headerValues } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createPortfolioGroupApi(apiClient: ApiClient) {
    const getByUnderlyingAsset = async (underlyingAssetId: number): Promise<PortfolioGroupDto[] | null> => {
        try {
            const response = await apiClient.get<PortfolioGroupDto[]>(
                `/api/underlying-assets/${underlyingAssetId}/portfolio-groups`,
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const create = async (
        underlyingAssetId: number,
        portfolioGroup: PortfolioGroupCreateDto,
    ): Promise<number | null> => {
        try {
            const response = await apiClient.post<number, PortfolioGroupCreateDto>(
                `/api/underlying-assets/${underlyingAssetId}/portfolio-groups`,
                portfolioGroup,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const update = async (portfolioGroup: PortfolioGroupDto): Promise<PortfolioGroupDto | null> => {
        try {
            const response = await apiClient.put<PortfolioGroupDto, PortfolioGroupDto>(
                "api/portfolio-groups",
                portfolioGroup,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const deleteById = async (id: number): Promise<boolean> => {
        try {
            const response = await apiClient.delete(`api/portfolio-groups/${id}`);
            return response !== null;
        } catch (error: any) {
            console.log(error);
            return false;
        }
    };

    return {
        getByUnderlyingAsset,
        create,
        update,
        deleteById,
    };
}
